import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MESSAGE } from 'src/app/constants/storage-elements';
import { ROUTES } from 'src/app/route/routes';
import { SessionStorageService } from 'src/app/service/session-storage.service';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss'],
  standalone: false
})
export class MessagesComponent implements OnInit {
  public datasource: any;

  constructor(
    private router: Router,
    private sStorageService: SessionStorageService
  ) {}

  ngOnInit(): void {
    this.datasource = `message.${this.sStorageService.getElement(MESSAGE)}`;
  }

  goToHome() {
    this.router.navigate([ROUTES.HOME.path]);
  }
}
